"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelection = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var LanguageSelectionStyles_1 = require("./LanguageSelectionStyles");
exports.LanguageSelection = react_1.default.memo(function (_a) {
    var handleLanguageChange = _a.handleLanguageChange, languages = _a.languages, defaultLanguage = _a.defaultLanguage;
    var _b = react_1.useState(defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : ''), selectedLanguage = _b[0], setSelectedLanguage = _b[1];
    var classes = LanguageSelectionStyles_1.useStyles();
    var changeLanguage = react_1.useCallback(function (event) {
        setSelectedLanguage(event.target.value);
        handleLanguageChange(event.target.value);
    }, [handleLanguageChange]);
    return (react_1.default.createElement(core_1.Box, { display: "flex", padding: 1, className: classes.box },
        react_1.default.createElement(core_1.Select, { className: classes.select, variant: 'outlined', onChange: changeLanguage, value: selectedLanguage, inputProps: {
                classes: {
                    icon: classes.icon,
                },
            } }, languages.map(function (l) {
            return (react_1.default.createElement(core_1.MenuItem, { key: l, value: l }, l.toUpperCase()));
        }))));
});
exports.LanguageSelection.displayName = 'LanguageSelection';
exports.default = exports.LanguageSelection;
//# sourceMappingURL=LanguageSelection.js.map